/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  function setHeight() {
    if ($(window).width() > 600 ) {
      $('.main > .row').not('.row-fluid').height($(window).height());
    }
    else {
      $('.main > .row').not('.row-fluid').css('height', 'auto');
    }    
  }

  var Sage = {
    // All pages
    'common': {
      init: function() {
        setHeight();
        $(window).on('resize', function () {
          setHeight()
        });
        

        $('.img-holder').each( function() {
          if( isMobile.any ) {
            $(this).imageScroll({
              container: $(this).parent(),
              coverRatio: 1,
              parallax: false,
            });
          } else {
            $(this).imageScroll({
              container: $(this).parent(),
              coverRatio: 1,
              parallax: true,
            });
          }
        });

        $('#menu-toggle').on('click', function() {
          $(this).toggleClass('open');
          $('.nav-primary').toggleClass('open');
        });

        if ( $('body.home').length > 0 ) {

          $(document).on("scroll", onScroll);

          $('ul.nav').on('click', 'a', function(e) {
            $('.current-menu-item').not($(this).parent()).removeClass('current-menu-item');
            $(this).parent().addClass('current-menu-item');
            var index = $(this).parent().index();
            $('.main > div').eq(index).velocity("scroll", { duration: 1000, easing: "easeOutBack" });
            e.preventDefault();
          });
        }
      },
      finalize: function() {
        var loadedImageCount = 0, imageCount;

        $('body').imagesLoaded({ background: true })
          .done( function( instance ) {
            if (getCookie("age") == "allow") {
              $('.loading').velocity("fadeOut", { duration: 1000 });
            } else {
              $('.confirmation').velocity("fadeIn", { duration: 500 });
              $('.confirmation').on('click', 'button', function() {
                var value = $(this).val();

                if (value == "hide") {
                  setCookie("age", "allow", 365);
                  $('.loading').velocity("fadeOut", { duration: 1000 });
                } else {
                  window.location = "http://google.com";
                }
              });
            }
          })
          .progress( function( instance, image ) {
            loadedImageCount++;
            var val = 101 - ((loadedImageCount / instance.images.length) * 100);
            $('#beergradient').velocity({ y1: val+'%' }, { duration: 10 });
          });
      }
    }
  };

  var onScroll = function(event){
    var scrollPos = $(document).scrollTop();
    var header = $('header.banner');
    $('ul.nav li').each(function () {
        var currLink = $(this);
        var index = $(this).index();
        var refElement = $('.main > div').eq(index);
        if (refElement.position().top <= scrollPos && refElement.position().top + refElement.outerHeight() > scrollPos) {
            $('.current-menu-item').removeClass("current-menu-item");
            currLink.addClass("current-menu-item");
            if (refElement.data('header')) {
              header.addClass('light');
            } else {
              header.removeClass('light');
            }
        }
        else{
            currLink.removeClass("current-menu-item");
        }
    });
  };

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
  }


  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
